import { Button, InputBase, styled, Typography } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 64px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    max-width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;

export const HeaderRowW = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const BreadcrumbW = styled(Typography)<{ isPrivate: boolean }>`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-top: ${({ isPrivate }) => (isPrivate ? '16px' : '0px')};
  max-width: 590px;
  direction: rtl;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    color: ${({ theme }) => theme.palette.primary.p040};
    font-weight: 700;
  }
`;

export const HeaderActionsW = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MobileSearchRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SearchInputW = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.palette.white.main};
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 8px 14px;
  width: 260px;
`;

export const SearchInput = styled(InputBase)`
  font-size: 14px;
  flex: 1;
`;

export const TabsAndFiltersW = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TabsW = styled('div')`
  display: flex;
  gap: 12px;
  flex: 1;
  align-items: center;
`;

export const TabBtnW = styled('button')<{ active?: boolean; isMobileX?: boolean }>`
  height: 44px;
  padding: ${({ isMobileX }) => (isMobileX ? '12px' : '12px 32px')};
  border: 1px solid
    ${({ theme, active }) => (active ? theme.palette.info.main : theme.palette.primary.grey)};
  border-radius: 8px;
  background: ${({ theme, active }) => (active ? '#fff' : theme.palette.white.main)};
  color: ${({ theme, active }) => (active ? theme.palette.info.main : theme.palette.primary.main)};
  font-weight: 500;
  font-size: ${({ isMobileX, active }) => (active ? '14px' : isMobileX ? '14px' : '15px')};
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const FiltersW = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const FilterBtnW = styled(Button)`
  text-transform: none;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.p080};
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 5px 12px;
  background-color: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

export const FilterIconBtnW = styled(Button)`
  min-width: unset;
  padding: 6px 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  background-color: ${({ theme }) => theme.palette.white.main};

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
`;

export const TableHeaderW = styled('div')`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1.5fr 2fr auto;
  padding: 8px 16px;
  gap: 12px;
  margin-bottom: 4px;
  @media (max-width: 1023px) {
    display: none;
  }
`;

export const TableColHeaderW = styled(Typography)`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p040};
`;
